<template>
  <div class="homebox">
    <img class="homebg" src="~@/assets/homebg.png" />
    <div class="home-contentbox">
      <div class="content-title">万商行业词库查询系统</div>
      <div class="content-box">
        <el-input class="input" v-model="code" placeholder="请输入代理商准入码"></el-input>
        <el-button type="success" @click="goSearch(1)" v-clickAgain>精确搜索</el-button>
        <el-button type="primary" @click="goSearch(2)" v-clickAgain>优选搜索</el-button>
      </div>
    </div>
    <div class="home-footer">
      Industry expert thesaurus intelligent optimization system
    </div>
  </div>
</template>
  
<script>
import { getAdminList } from "@/server/api";

export default {
  data() {
    return {
      code: "",
    };
  },
  mounted() { },
  methods: {
    goSearch(e) {
      if (!this.code) {
        this.$message({
          message: "请输入代理商准入码",
          type: "warning",
        });
        return;
      }
      this.checkCode(e);
    },
    async checkCode(e) {
      var that = this;
      const { data } = await getAdminList({
        auth_code: this.code,
      });
      if (data != "暂无数据") {
        if (e == 1) {
          that.$router.push({
            path: "/views/accurateSearch",
            query: { code: that.code },
          });
        } else {
          that.$router.push({
            path: "/views/optimizationSearch",
            query: { code: that.code },
          });
        }
      } else {
        this.$message({
          message: "请输入正确的代理商准入码",
          type: "error",
        });
      }
    },
  },
};
</script>
  
<style lang="scss" scoped>
.homebox {
  width: 100vw;
  height: 100vh;
  position: relative;

  .homebg {
    width: 100%;
    height: 100%;
    position: absolute;
  }

  .home-contentbox {
    position: relative;
    text-align: center;
    padding-top: 390px;

    .content-title {
      font-size: 40px;
      font-family: AlimamaShuHeiTi-Bold, AlimamaShuHeiTi;
      font-weight: bold;
      color: #ffffff;
    }

    .content-box {
      margin-top: 48px;
    }

    .input {
      width: 480px;
      margin-right: 10px;
    }
  }

  .home-footer {
    position: absolute;
    bottom: 32px;
    font-size: 12px;
    color: #ffffff;
    font-family: PingFangSC-Regular, PingFang SC;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/home/index.vue